import React from 'react';
import useSWR from 'swr';

import { useHandleSWR } from '~/libs/helpers'
import useGlobalState from '~/libs/context';

import TaxReturnImage from '~/public/official-docs/tax-return-reiwa-3.png';
import { CoveredCells, LabelCell, RawValueCell, ValueCell } from '../styles/StyledTaxReturn';
import { OfficialDocumentContainer } from './OfficialDocumentContainer';

const TaxReturn_3 = ({ isEnglish }) => {
	const { year } = useGlobalState(); 
	const { data: swrBalanceSheet } = useSWR(`/api/metrics/balanceSheet?year=${year}`);
  const { data: balanceSheet } = useHandleSWR(swrBalanceSheet, { assets: [], liabilities: [], totals: [] }, true);
  // TODO: Maybe we should find a way to get the totals directly from balanceSheet to avoid two requests
  const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { totals: [] }, true);
  const force = isEnglish;
  const rowHeight = 3.69;
  const rows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

	return (
    <OfficialDocumentContainer image={TaxReturnImage}>

      {/* Columns labels */}
      <LabelCell en={"Name of depreciable assets"} coords={[6.45, 4.5]} width={6.7} height={7.45} force={force} />
      <LabelCell en={"QTY"} coords={[6.45, 11.6]} width={3.2} height={7.45} force={force} />
      <LabelCell en={"Buy date"} coords={[6.45, 15.2]} width={3.15} height={7.45} force={force} />
      <LabelCell en={"Purchase amount"} coords={[6.45, 18.8]} width={7.7} height={7.45} force={force} />
      <LabelCell en={"Depreciable base"} coords={[6.45, 26.9]} width={7.7} height={7.45} force={force} />
      <LabelCell en={"Base"} coords={[6.45, 34.95]} width={3.2} height={7.45} force={force} />
      <LabelCell en={"Length"} coords={[6.45, 38.55]} width={3.2} height={7.45} force={force} />
      <LabelCell en={"Rate"} coords={[6.45, 42.08]} width={3.28} height={7.45} force={force} />
      <LabelCell en={<>Pro<br />rata</>} coords={[6.45, 45.75]} width={3.2} height={7.45} force={force} />
      <LabelCell en={"Current year"} coords={[6.45, 49.3]} width={6.75} height={7.45} force={force} />
      <LabelCell en={"Special"} coords={[6.45, 56.5]} width={6.75} height={7.45} force={force} />
      <LabelCell en={"Total"} coords={[6.45, 63.7]} width={6.75} height={7.45} force={force} />
      <LabelCell en={"Pro %"} coords={[6.45, 70.9]} width={3.1} height={7.45} force={force} />
      <LabelCell en={"Pro amount"} coords={[6.45, 74.45]} width={6.75} height={7.45} force={force} />
      <LabelCell en={"Net value"} coords={[6.45, 81.7]} width={6.75} height={7.45} force={force} />
      <LabelCell en={"Notes"} coords={[6.45, 88.9]} width={6.6} height={7.45} force={force} />

      {/* Rows */}
      {rows.map(x => <>
        <RawValueCell left value="" coords={[rowHeight * x + 14.45, 4.62]} width={6.7} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 11.6]} width={3.2} height={3.1} force={force} />
        <RawValueCell center value={0} coords={[rowHeight * x + 14.45, 15.2]} width={1.5} height={3.1} force={force} />
        <RawValueCell center value={0} coords={[rowHeight * x + 14.45, 16.95]} width={1.5} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 20]} width={5.3} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 26.9]} width={6.6} height={3.1} force={force} />
        <LabelCell en={""} coords={[rowHeight * x + 14.45, 34.95]} width={3.2} height={3.1} force={force} />
        <RawValueCell center value={0} coords={[rowHeight * x + 14.45, 38.55]} width={3.2} height={3.1} force={force} />
        <LabelCell en={""} coords={[rowHeight * x + 14.45, 42.15]} width={3.2} height={3.1} force={force} />
        <RawValueCell center value={1} coords={[rowHeight * x + 14.15, 45.75]} width={3.2} height={1.9} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 49.3]} width={5.8} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 56.5]} width={5.8} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 63.7]} width={5.8} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 70.9]} width={2.3} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 74.45]} width={5.8} height={3.1} force={force} />
        <RawValueCell value={0} coords={[rowHeight * x + 14.45, 81.7]} width={5.8} height={3.1} force={force} />
        <RawValueCell left value="" coords={[rowHeight * x + 14.45, 88.9]} width={6.6} height={3.1} force={force} />
      </>)}

      {/* Totals */}
      <LabelCell en={"Total"} coords={[rowHeight * 11 + 14.45, 4.5]} width={6.7} height={2.75} force={force} />
      <RawValueCell value={0} coords={[rowHeight * 11 + 14.45, 49.3]} width={5.8} height={2.75} force={force} />
      <RawValueCell value={0} coords={[rowHeight * 11 + 14.45, 56.5]} width={5.8} height={2.75} force={force} />
      <RawValueCell value={0} coords={[rowHeight * 11 + 14.45, 63.7]} width={5.8} height={2.75} force={force} />
      <RawValueCell value={0} coords={[rowHeight * 11 + 14.45, 74.45]} width={5.8} height={2.75} force={force} />
      <RawValueCell value={0} coords={[rowHeight * 11 + 14.45, 81.7]} width={5.8} height={2.75} force={force} />
      <RawValueCell left value="" coords={[rowHeight * 11 + 14.45, 88.9]} width={6.6} height={2.75} force={force} />

      {/* Coming soon... */}
      <CoveredCells coords={[62, 2]} width={95} height={38}>Coming soon!</CoveredCells>

    </OfficialDocumentContainer>
	);

};

export default TaxReturn_3;